/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Empty_SearchInputs */

const cs_social_hub_empty_search = /** @type {(inputs: Social_Hub_Empty_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné nemovitosti neodpovídají hledání.`)
};

const en_social_hub_empty_search = /** @type {(inputs: Social_Hub_Empty_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No properties match your search.`)
};

/**
* | output |
* | --- |
* | "No properties match your search." |
*
* @param {Social_Hub_Empty_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_empty_search = /** @type {((inputs?: Social_Hub_Empty_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Empty_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_empty_search(inputs)
	return cs_social_hub_empty_search(inputs)
});